import { Section } from '../layout/Section';
import { Pill } from '../ui/Pill';
import { Button } from '../ui/Button';
import { Picture } from '../ui/Picture';
import { hero } from '../../data/landing';
import styles from './Hero.module.css';

/** Decorative bar chart inside the 99% card; heights are fixed, not data. */
const BAR_HEIGHTS = [46, 74, 58, 88, 40];

export function Hero() {
  const { stats } = hero;

  return (
    <Section className={styles.hero} spacing="tight">
      <div className={styles.grid}>
        <div className={styles.copy}>
          <Pill>{hero.eyebrow}</Pill>

          <h1 className={`${styles.headline} u-hero u-gradient-text`}>
            {hero.headline.map((line) => (
              <span key={line} style={{ display: 'block' }}>
                {line}
              </span>
            ))}
          </h1>

          <p className={`${styles.body} u-body-lg`}>{hero.body}</p>

          <div className={styles.ctas}>
            <Button to={hero.primaryCta.to} size="lg" icon="arrow-right-circle">
              {hero.primaryCta.label}
            </Button>
            <Button to={hero.secondaryCta.to} size="lg" variant="outline">
              {hero.secondaryCta.label}
            </Button>
          </div>
        </div>

        <div className={styles.media}>
          <Picture
            name="hero-secondary"
            alt=""
            priority
            fit="contain"
            ratio="1094 / 706"
            sizes="(max-width: 1023px) 92vw, 76vw"
            className={styles.portrait}
          />

          <div className={styles.floats}>
            <div className={`${styles.float} ${styles.livePill}`}>
              <span className={styles.liveDot} aria-hidden="true" />
              {stats.live.label}
              <span className={styles.liveSep} aria-hidden="true">
                |
              </span>
              <strong>{stats.live.value}</strong>
            </div>

            <div className={`${styles.float} ${styles.successCard}`}>
              <p className={styles.successValue}>
                <span className={styles.successNum}>{stats.success.value}</span>
                <span className={styles.successUnit}>{stats.success.unit}</span>
              </p>
              <p className={styles.successLabel}>{stats.success.label}</p>
              <div className={styles.bars} aria-hidden="true">
                {BAR_HEIGHTS.map((h, i) => (
                  <span key={i} className={styles.bar}>
                    <span className={styles.barFill} style={{ height: `${h}%` }} />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
